const LIVE_REGION_ID = 'a11y-live-region';

function getLiveRegion(): HTMLElement {
  let region = document.getElementById(LIVE_REGION_ID);
  if (!region) {
    region = document.createElement('div');
    region.id = LIVE_REGION_ID;
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.className = 'sr-only';
    document.body.appendChild(region);
  }
  return region;
}

/** Announces a message to screen readers via a polite live region. */
export function announce(message: string): void {
  const region = getLiveRegion();
  region.textContent = '';
  window.requestAnimationFrame(() => {
    region.textContent = message;
  });
}
